import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2ed4d20b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "courseRecommend border-box p-lr32 p-b32" };
const _hoisted_2 = {
    key: 0,
    class: "listBox"
};
const _hoisted_3 = { class: "listTitle font-36 font-w500" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    key: 1,
    class: "white-bg p-lr20 radius-16 p-t24 border-box"
};
import CourseList from '@/components/course/courseList.vue';
import MedicaseItem from '@com/list/medicaseItem.vue';
import ArticleList from '@/components/list/articleList.vue';
import mallList from '@/components/list/mallList.vue';
import { ref, watch } from 'vue';
import { getUserId } from '@/widget';
import { getCarrRecommend } from '@/api/video';
export default /*#__PURE__*/ _defineComponent({
    props: {
        moduleType: {
            type: String,
            default: 'album'
        },
        courseId: {
            type: String || Number,
            default: '0'
        },
        loaded: {
            default: false,
            type: Boolean
        },
        isLiveOpen: {
            default: false,
            type: Boolean
        }
    },
    emits: ['clickRecommend'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const userId = getUserId();
        // 获取推荐课程
        const recData = ref([]);
        const getRecommend = () => {
            getCarrRecommend(props.moduleType, props.courseId, userId).then(res => {
                if (res.code == 200) {
                    let { data } = res;
                    for (let val in data) {
                        recData.value.push({
                            type: val,
                            title: data[val].title,
                            list: data[val].list
                        });
                    }
                }
            });
        };
        watch(() => props.loaded, n => {
            if (n) {
                getRecommend();
            }
        });
        const toRecommend = data => {
            emits('clickRecommend', data);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recData.value, (item, key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (item.list.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                                (item.type == 'mall')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(mallList, {
                                            list: item.list,
                                            onToRecommend: toRecommend,
                                            key: key
                                        }, null, 8, ["list"])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        (item.type == 'article')
                                            ? (_openBlock(), _createBlock(ArticleList, {
                                                key: 0,
                                                list: item.list,
                                                onToRecommend: toRecommend
                                            }, null, 8, ["list"]))
                                            : (item.type == 'exercise')
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.list, (exercise, key) => {
                                                    return (_openBlock(), _createBlock(MedicaseItem, {
                                                        class: "mt-32",
                                                        key: key,
                                                        item: exercise,
                                                        onToRecommend: toRecommend
                                                    }, null, 8, ["item"]));
                                                }), 128))
                                                : (/^(master_class|omo|open)$/.test(item.type))
                                                    ? (_openBlock(), _createBlock(CourseList, {
                                                        key: 2,
                                                        recommend: true,
                                                        onToRecommend: toRecommend,
                                                        list: item.list,
                                                        isLiveOpen: __props.isLiveOpen
                                                    }, null, 8, ["list", "isLiveOpen"]))
                                                    : _createCommentVNode("", true)
                                    ]))
                            ]))
                            : _createCommentVNode("", true)
                    ], 64));
                }), 256))
            ]));
        };
    }
});
